import LiveChatBase from './LiveChatBase';

/**
 * A special class built like a state machine for all widgets used :
 . to specify analytic service used to track a widget event on every state change
 . to specify logger used to log on every state change
 . to store state in browser cache (e.g. cookie or local/session storage)
 . to notify other codebase of state changes in a cross-iframe manner
 . to invoke callback function onStateChanged
 */
import WidgetStateEventRegistery from './WidgetStateEventRegistery';

export default class WidgetStateMachine extends LiveChatBase {
    constructor(options) {
        super(options);
        this.widget = options.widget;
        this.states = WidgetStateEventRegistery().getEntry(this.widget);
        this.analytics = options.analytics;
        this.storage = options.storage;
        this.onStateChanged = options.onStateChanged;
    }

    /*
     * Method used to store state as cookie automatically; this.super() in child class methods causes this method to be invoked by base class
     * 1. log state transition
     * 2. store state value
     * 3. falsify old state
     * 4. log this state transition in history cookie/store
     * 5. save all state
     * 6. set current/new state
     */
    changeState(options /* _to, value, _from */) {
        if (!options.toState) {
            // no state specified? exit
            return;
        }
        const widget = options.origin ? options.origin : this.widget;
        const objToState = WidgetStateEventRegistery().getEntry(widget, options.toState);

        if (objToState.event) {
            this.analytics && this.analytics.track(objToState.category, objToState.event);
            this.analytics &&
                this.analytics.trackTime(objToState.category, objToState.event, options.value);
        }
        // set widget's current state as cookie if required
        if (objToState.maintainCookie) {
            this.storage && this.storage.api.Store(widget, objToState.state);
        }
        if (options.persist) {
            // expilictiy store widget state as Cookie
            this.storage && this.storage.api.Store(widget + objToState.state, options.value);
        }
        this.currentState = objToState.state;
        // when in dev mode, comment out if you don't like;-)
        if (ApexChat.isInDevMode) {
            this.logger && this.logger.log({ text: widget + objToState.state });
        }
        // finally notify cross-iframe
        this.onStateChanged &&
            this.onStateChanged({ origin: widget, state: objToState.state, value: options.value });
    }

    addStateHandler(s, h) {
        this.subscribe(this.widget + s, h);
    }

    setStateValue(options) {
        const widget = options.widget ? options.widget : this.widget;
        const { state } = options;
        const { value } = options;
        if (!state) {
            throw 'State is mandatory';
        }
        if (value == undefined) {
            throw 'Value is mandatory';
        }
        const cookie = widget + state;
        this.storage && this.storage.api.Store(cookie, value);
    }

    getStateValue(w, s) {
        // get state of a widget with/without a particular state specified
        const widget = w || this.widget;
        // get only specified state value
        if (s) {
            const cookie = widget + s;
            const value = this.storage.api.Get(cookie);
            return value ? JSON.parse(value) : null;
        }
        return this.storage.api.Get(widget);
    }

    getCurrentState(state) {
        if (state) {
            return this.storage.api.Get(this.widget + state);
        }
        return this.storage.api.Get(this.widget);
    }
}
